import React from 'react';
import { Layout,message }   from 'antd';
import Sidebar from "./components/Sidebar";
import Frame from './components/Frame';
import {OpenLinksContext} from './context'
import type { UrlItemArray } from './context';
import axios from 'axios'
import { useNavigate } from 'react-router-dom'
import API from './api/api'
import Config from './config/pages'
import cookie from 'react-cookies'
const { Sider, Content } = Layout;



interface IMenuInfo {
  name: string;
  routeUrl: string;
  childMenus: Array<IMenuInfo>;
}
interface IMenuRespListItem {
  sysName: string;
  sysHomeUrl: string;
  menuInfos: Array<IMenuInfo>;
}
type MenuRspListArray = IMenuRespListItem[]

function App() {
  const emptyArray: UrlItemArray = []
  //const emptyMenu:MenuArray = []
  const emptyMenuRsp: MenuRspListArray = []
  //current routes (user clicked menu)
  const [routes, setRoutes] = React.useState({ urls: emptyArray, active: 0 })
  //all menus data
  const [menus, setMenus] = React.useState<Array<IMenuRespListItem>>(emptyMenuRsp)
  //menu loaded flag
  const [init, setInit] = React.useState(false)
  //useNavigate
  const navigate = useNavigate()
  //add 
  const add = (k: string, t: string, u: string) => {
    console.log("add " + t + " " + u)
    //urls 副本
    const urls: UrlItemArray = routes.urls.slice();
    //key 索引
    const keyArr = urls.map(u => u.key)
    console.log("in  add ", keyArr)
    if (keyArr.includes(k)) {
      setRoutes({ urls, active: keyArr.indexOf(k) });
    } else {
      urls.push({ key: k, title: t, url: u, ts: 0 });
      setRoutes({ urls, active: urls.length - 1 });
    }
  }

  //remove
  const remove = (index: number) => {
    const urls = routes.urls.slice();
    urls.splice(index, 1);
    setRoutes({ urls, active: 0 });
  }

  //set active
  const active = (index: number) => {
    setRoutes({ ...routes, active: index });
  }

  //reload
  const reload = (index: number) => {
    //reload reset urls item's ts
    //urls 副本
    const urls: UrlItemArray = routes.urls.slice();
    if (index < urls.length) {
      urls[index].ts = urls[index].ts + 1
    }
    console.log("reload", urls)
    setRoutes({ ...routes, urls });
  }
  const [messageApi, contextHolder] = message.useMessage();

  // 获取菜单数据
  const getMenuData = async () => {
    /*
    const res = await getMenuList()
    console.log("get menu",res)
    const menus:MenuArray = []
    setMenus(Object.assign(menus,res))
    console.log("menus",menus)
    
    const res =   getMenuList()
    const menuRespList:MenuRspListArray = []
    setMenus(Object.assign(menuRespList,res.data.menuRespList))
    setInit(true)
    return*/

    setInit(false)
    const startUnixTimestamp = (new Date()).getTime()
    axios.get(API.queryMenu,{headers: {'EFToken':window.localStorage.getItem('token')}})
    .then(res=>{
      console.log("axios",res)
      const endUnixTimestamp = (new Date()).getTime()
      const useTime = endUnixTimestamp - startUnixTimestamp
      console.log("user time",useTime)
      if(res && res.data && res.data.code === 200 && res.data.data){
        const menuRespList:MenuRspListArray = []
        const signin1st = window.localStorage.getItem('signin1st')?true:false
        if(signin1st){
          console.log("signin1st true")
          window.localStorage.removeItem("signin1st")
          if(useTime<Config.LOADING_INTERVAL){
            console.log("waiting "+(Config.LOADING_INTERVAL-useTime))
            setTimeout(()=>{
              console.log("render menu "+ (new Date()).getTime())
              setMenus(Object.assign(menuRespList,res.data.data.menuRespList))
              setInit(true)
            },Config.LOADING_INTERVAL-useTime)
          }else{
            setMenus(Object.assign(menuRespList,res.data.data.menuRespList))
            setInit(true)
          }
        }else{
          setMenus(Object.assign(menuRespList,res.data.data.menuRespList))
          setInit(true)
        }
      }else{
        setInit(true)
      }
    })
    .catch(function (error) {
      //handle error satuation
      if(error && error.response && error.response.status == 401){
        console.log(error.response.statusText)
        messageApi.error(error.response.statusText+'请重新登录');
        
        window.localStorage.removeItem("token")
        window.localStorage.removeItem("email")

        const token_name = cookie.load('token_name') || 'token'
        cookie.remove('token_name')
        cookie.remove(token_name,{domain: '.english1.cn',path: '/',secure: true})
        //cookie.remove('email')
        navigate('/signin')
        return
      }
      console.log("axios error",error)
      messageApi.error('服务器发生异常，请联系管理员');
      //模拟数据 仅用于调试
      //const res =   getMenuList()
      //const menuRespList:MenuRspListArray = []
      //setMenus(Object.assign(menuRespList,res.data.menuRespList))
      setInit(true)
    })
    
      
  }
  React.useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search)
    //save token in localstorage
    const token=queryParams.get("token")
    const email=queryParams.get("email")
    const token_name = queryParams.get("token_name") ||'token'

    if(token && email){
      window.localStorage.setItem("token",token)
      window.localStorage.setItem("email",email)
      cookie.save('token_name',token_name,{})
      cookie.save(token_name, token,{domain: '.english1.cn',path: '/',secure: true})
      //cookie.save('email', email,{})
      navigate('/index')
    }
    

    if((window.localStorage.getItem("token"))){
      getMenuData()
    }else{
      console.log("EFToken not foud, signin")
      navigate('/signin')
    }
    
  }, [])
  return (
    <OpenLinksContext.Provider value={{ routes, menus, init, add, remove, active, reload }}>
      <Layout>
        <Sider className="h-[100vh]"><Sidebar /></Sider>
        <Content className="h-[100vh]" ><Frame /></Content>
        {contextHolder}
      </Layout>
      {
        Config.PRE_START_PAGE.map(url=>{
          return <iframe src={url} className='hidden' width={0} height={0} title="hidden" />
        })
      }
    </OpenLinksContext.Provider>
  );
}

export default App;
